import $ from "jquery"
import _ from "underscore"
import Ext from "Ext"
import messageResource from "../messageResource"
import SharedUserButtonMenu from "../controls/selectorControls/at_shared_user_button_menu"
import CoarseSelection from "../enums/CoarseSelection"
import TwoLevelSelection from "../controls/selectorControls/two_level_selection"
import SelectorPanelWithApplyButtonHelper from "../controls/selectorControls/at_selector_panel_with_apply_button_object"
import HierarchySelectorDropdownButton from "../controls/selectorControls/at_hierarchy_selector_dropdown_button"
import DhtmlTitle from "../dhtml_title"
import CustomerProjectSelectorTwoGenericOptionsPanel from "./at_customer_project_two_generic_options_panel"
import {CustomersProjectsSelectionQualifier} from "../constants"
import {arrayToSet} from '../atUtils'

export default class CPReportSelector {
    constructor(panelConfig)
    {
        this.panelConfig = _.defaults(panelConfig || {}, {
            isCustomersProjectsFiltered: true,
            allActiveItemsOptionLabelKeyFiltered: "projects_customers_selector.report.all_active_projects_customers_filtered",
            allItemsOptionLabelKeyFiltered: "projects_customers_selector.report.all_projects_customers_filtered"
        });
    }

    /**
     * Init selector with report config where placed cpSelectorData (selected customer, projects, qualifier)
     * Create button and disable it while CPReportSelector.initializeData not performed
     * This code is modification of CPSelectorServerUtil and CPSelectorClientUtil classes
     * @returns {*}
     */
    init(customersProjectsSelection, cpSelectorId, changedCallback, withApplyButton, firstOpenCallback = () => {})
    {
        this.cpSelection = customersProjectsSelection;
        this.predefinedState = this._createPredefinedStateFromSelection(customersProjectsSelection);

        // init panel
        var panelConfig = Ext.apply(this.panelConfig, {});
        if (withApplyButton)
            Ext.apply(panelConfig, SelectorPanelWithApplyButtonHelper.getApplyButtonExtension(CustomerProjectSelectorTwoGenericOptionsPanel));
        this.panel = new CustomerProjectSelectorTwoGenericOptionsPanel(panelConfig);

        this.menu = new SharedUserButtonMenu({panel: this.panel});
        // set handler for get predefined state
        this.panel.setGetPredefinedSelectionCallback(() => this.predefinedState)

        // override process without use ajax call ( some code copied from AT.HierarchicalSelectorPanel.processFirstPanelOpen)
        this.panel.processFirstPanelOpen = () => {
            this.panel.treePanel = document.createElement("div")
            const treePanelClasses = this.panel.getTreePanelClasses()
            treePanelClasses.push("spinnerPanel") // spin while panel is not loaded
            this.panel.treePanel.className = treePanelClasses.join(" ")
            const targetEl = this.panel.detailsContainer.el.dom
            const firstChild = targetEl.childNodes[0]
            if (firstChild) {
                targetEl.insertBefore(this.panel.treePanel, firstChild)
            }
            else {
                targetEl.appendChild(this.panel.treePanel)
            }
            this.panel.initializeSelector(this.preloadedData)
            firstOpenCallback()
        }
        this.wasChanged = false;
        var buttonConfig = {
            renderTo: cpSelectorId,
            labelCls: "hierarchySelectorButton",
            menu: this.menu,
            tooltipObject: new DhtmlTitle("form-field-tooltip")
        };
        // create drop down button
        this.button = this._createDropDownButton(buttonConfig);
        this._initDropDownButton(changedCallback);

        return this;
    }


    _createDropDownButton(buttonConfig)
    {
        return new HierarchySelectorDropdownButton(buttonConfig);
    }


    _initDropDownButton(changedCallback)
    {
        // show message while data download
        this.button.setText(messageResource.getMessage('saved_reports.cp_selector.data_loading'));
        this.button.setTooltipEnabled(false);
        // of button while data not loaded
        this.button.setEnabled(false);
        var self = this;
        this.button.setMenuHideCallback(function()
                                        {
                                            if (changedCallback)
                                            {
                                                self.wasChanged = false;
                                                changedCallback();
                                            }
                                        });
    }

    getButton() {
        return this.button
    }


    _createPredefinedStateFromSelection(cpSelection)
    {
        return {
            selection: cpSelection.qualifier == CustomersProjectsSelectionQualifier.SELECTED ?
                       new TwoLevelSelection(cpSelection.customers, cpSelection.projects) : TwoLevelSelection.emptySelection(),
            optionValue: cpSelection.qualifier == CustomersProjectsSelectionQualifier.SELECTED ? CoarseSelection.SPECIFIC :
                         cpSelection.qualifier == CustomersProjectsSelectionQualifier.ALL ? CoarseSelection.ALL : CoarseSelection.ALL_ACTIVE,
            showInactive: cpSelection.showArchivedProjects,
            manageScopeOnly: cpSelection.includeOnlyManagementScope,
        };
    }


    setWasChanged()
    {
        this.wasChanged = true;
    }

    /**
     * Use this method while data load from server is performed
     * Activate button and set correct label
     * @param customersProjects CPList from server
     * @param customersWithMaIds array of customers ids user has another MA inside
     * @param projectsWithMaIds array of projects ids user has another MA inside
     */
    initializeData(customersProjects, customersWithMaIds, projectsWithMaIds)
    {
        this.preloadedData = customersProjects

        if (projectsWithMaIds) {
            this.preloadedData.entirelyManageable = this.preloadedData.projects.length === projectsWithMaIds.length
            this.preloadedData.manageable = projectsWithMaIds.length > 0

            let projectWithMASet = arrayToSet(projectsWithMaIds)
            for (let project of this.preloadedData.projects) {
                if (projectWithMASet[project.id]) {
                    project.fromManagementScope = true
                }
            }
        }

        // remove selection c&p that were deleted
        this._removeDeletedCPFromSelection(customersProjects, this.cpSelection);
        // set text when data is loaded
        this.button.setText(this._makePredefinedSelection(customersProjects));
        this.button.setEnabled(true);
    }

    _removeDeletedCPFromSelection(cpData, cpSelection)
    {
        var selectedCustomers = cpSelection.customers;
        var availableCustomersMap = {};
        for (var i = 0; i < cpData.customers.length; i++)
        {
            availableCustomersMap[cpData.customers[i].id] = true;
        }

        var selectedProjects = cpSelection.projects;
        var availableProjectsMap = {};
        for (i = 0; i < cpData.projects.length; i++)
        {
            availableProjectsMap[cpData.projects[i].id] = true;
        }

        // remove not exists selection
        for (i = selectedProjects.length - 1; i >= 0; i--)
        {
            if (!availableProjectsMap[selectedProjects[i]])
            {
                selectedProjects.splice(i, 1);
            }
        }
        for (i = selectedCustomers.length; i >= 0; i--)
        {
            if (!availableCustomersMap[selectedCustomers[i]])
            {
                selectedCustomers.splice(i, 1);
            }
        }
    }

    /**
     * Create string for text in button
     * @returns {*} text of label
     * @private
     */
    _makePredefinedSelection(customersProjects) {
        const state = this.predefinedState
        if (state.optionValue === CoarseSelection.SPECIFIC) {
            let selectedCustomers = [...state.selection.getFirstLevel()]
            let selectedProjects = [...state.selection.getSecondLevel()]

            if (this.cpSelection.includeOnlyManagementScope) {
                const selectedCustomersSet = arrayToSet(selectedCustomers)
                const selectedProjectsSet = arrayToSet(selectedProjects)
                selectedProjects = []
                customersProjects.projects.forEach(project => {
                    if ((selectedProjectsSet[project.id] || selectedCustomersSet[project.customerId]) && project.fromManagementScope) {
                        selectedProjects.push(project)
                    }
                })
                return this.panel.getSelectionHelper().getShortDescriptionForCustomersAndProjects([], selectedProjects, undefined)
            } else if (selectedCustomers.length + selectedProjects.length === 1) {
                if (selectedCustomers.length === 1) {
                    // get data of selected customer
                    selectedCustomers[0] = ($.map(customersProjects.customers, function(n) {
                        if (n.id === selectedCustomers[0]) {
                            return n
                        }
                    }))[0]
                } else {
                    // get data of selected prj
                    selectedProjects[0] = ($.map(customersProjects.projects, function(n) {
                        if (n.id === selectedProjects[0]) {
                            return n
                        }
                    }))[0]
                }
            }

            return this.panel.getSelectionHelper().getDescription(new TwoLevelSelection(selectedCustomers, selectedProjects), undefined, state.showInactive)

        } else if (state.optionValue === CoarseSelection.ALL) {
            return this.panel.getAllSelectedMessage()
        } else {
            return this.panel.getAllActiveItemsMessage()
        }
    }

    /**
     * Return false if there no one selection or true otherwise
     * @returns {boolean}
     */
    checkSelected()
    {
        var isAllPredefined = this.predefinedState.optionValue == CoarseSelection.ALL_ACTIVE || this.predefinedState.optionValue == CoarseSelection.ALL;
        return !((this.panel.isAlreadyShown() && this.panel.isCustomOptionSelected() && this.panel.isEmptySelection())
                 || (!this.panel.isAlreadyShown() && this.predefinedState.selection.isEmpty() && !isAllPredefined));
    }

    /**
     * Save selected c&p in report config
     *
     */
    getCpSelection()
    {
        // if panel not shown do not read values from panel
        if (!this.panel.isAlreadyShown())
        {
            return this.cpSelection;
        }
        else
        {
            var selection = this.panel.getSelection(false);
            // update predefined state
            return {
                customers: selection.getFirstLevel(),
                projects: selection.getSecondLevel(),
                qualifier: (this.panel.isCustomOptionSelected()) ? CustomersProjectsSelectionQualifier.SELECTED :
                           ((this.panel.isAllItemsOptionSelected()) ? CustomersProjectsSelectionQualifier.ALL : CustomersProjectsSelectionQualifier.ALL_ACTIVE),
                showArchivedProjects: this.panel.getShowInactive(),
                includeOnlyManagementScope: this.panel.isShowOnlyManagementScope()
            };
        }
    }

    setInitialValueFromCurrent()
    {
        // only if panel already shown
        if (this.panel.isAlreadyShown())
        {
            var selection = this.panel.getSelection(false);
            var predefinedState = {
                selection: this.panel.isCustomOptionSelected() ?
                           new TwoLevelSelection(selection.getFirstLevel(), selection.getSecondLevel()) : TwoLevelSelection.emptySelection(),
                optionValue: (this.panel.isCustomOptionSelected()) ? CoarseSelection.SPECIFIC :
                             ((this.panel.isAllItemsOptionSelected()) ? CoarseSelection.ALL : CoarseSelection.ALL_ACTIVE),
                showInactive: this.panel.getShowInactive(),
                manageScopeOnly: this.panel.isShowOnlyManagementScope(),
            };
            this.panel.setPredefinedParameters(predefinedState);
            this.panel.loadState(predefinedState);
        }
    }

    /**
     * Set selection from customersProjectsSelection
     * Method sets new initial values of selector
     * @param customersProjectsSelection
     */
    setSelection(customersProjectsSelection)
    {
        this.predefinedState = this._createPredefinedStateFromSelection(customersProjectsSelection);
        // only if panel already shown
        if (this.panel.isAlreadyShown())
        {
            this.panel.loadState(this.predefinedState);
            this.panel.setPredefinedParameters(this.predefinedState);
            this.panel.resetState(true);
        }
        else
        {
            // need to update text label on button if c/p data is loaded from server and panel not show
            if (this.preloadedData)
            {
                this.button.setText(this._makePredefinedSelection(this.preloadedData));
            }
        }
    }

    resetSelection()
    {
        // if panel is shown
        if (this.panel.isAlreadyShown())
        {
            this.panel.resetState(true);
        }
    }

    isStateChanged()
    {
        return this.panel.isStateChanged();
    }

    saveState()
    {
        var cpSelection = this.getCpSelection();
        var predefinedState = this._createPredefinedStateFromSelection(cpSelection);
        this.panel.setPredefinedParameters(predefinedState);
        this.panel.loadState(predefinedState);
    }
}



// WEBPACK FOOTER //
// ./web/js/cp_selector/cp_selector_report_config.js